var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "label",
    {
      class: [
        _vm.selected ? "filter-button-label--selected" : "filter-button-label",
      ],
      attrs: { for: _vm.name + _vm.id },
      on: { click: _vm.toggleFilter, keypress: _vm.toggleFilterFromKeyPress },
    },
    [
      _c(
        "div",
        {
          staticClass: "button filter-button button-tertiary",
          attrs: { tabindex: "0" },
        },
        [
          _vm._v("\n    " + _vm._s(_vm.name) + "\n    "),
          _c("input", {
            staticClass: "filter-button-checkbox",
            attrs: {
              tabindex: "-1",
              type: "checkbox",
              id: _vm.id,
              name: _vm.name,
            },
            domProps: { checked: _vm.selected, value: _vm.id },
          }),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }